import PropTypes from 'prop-types';
import React from 'react';
import TreeSortingOptions from '../../../../model/TreeSortingOptions';
import useEnumerableModel from '../../../data/hooks/useEnumerableModel';
import itemIdValue from '../../../itemIdValue';
import useT from '../../utils/Translations/useT';
import MultiselectFilter from './MultiselectFilter';
import SelectBox from '../base/SelectBox';
import SelectBoxFilter from './SelectBoxFilter';

const TreeSortingSelector = props => {
  const t = useT();
  const { options } = useEnumerableModel(TreeSortingOptions);

  return <SelectBoxFilter options={options} title={t('Sort By')} {...props} />;
};

TreeSortingSelector.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

TreeSortingSelector.defaultProps = {
  value: null,
  onChange: null,
};

export default TreeSortingSelector;
